/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsBaseForGcp extends models.ServiceAccountCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsBaseForGcp");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsBaseForGcp.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsBaseForGcp>): ServiceAccountCredentialsBaseForGcp {
        let obj = Object.assign(new ServiceAccountCredentialsBaseForGcp(), model);
        ServiceAccountCredentialsBaseForGcp.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsBaseForGcp>): ServiceAccountCredentialsBaseForGcp {
        if (!model) return null;
        return ServiceAccountCredentialsBaseForGcp.newInstance(<ServiceAccountCredentialsBaseForGcp> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsBaseForGcp) {
        if (!obj) return;

        models.ServiceAccountCredentialsBaseForGcp.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsBaseForGcp): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsBaseForGcp.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
